import { CouponLineScanEventContainerModel } from "../../../../../../models/aggregates/erp";
import {
  ApiVisa,
  Core2Config,
  Pagination,
  PagingResponseModel,
  BasicApiResponseModel
} from "../../shared";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: "root" })
export class CouponLineScanEventService extends BaseApiPublicLoginTemplateService<CouponLineScanEventContainerModel, CouponLineScanEventContainerModel, CouponLineScanEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-events";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-events";
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-events/login-ep";
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "coupon-line-scan-events/login-entity-ep";
    this.httpClient = http;
  }

  getCouponLineScanEventByGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<CouponLineScanEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<CouponLineScanEventContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  getCouponLineScanEventByCriteria(pagination: Pagination, visa: ApiVisa):
  Observable<PagingResponseModel<CouponLineScanEventContainerModel>> {
    let url = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    if (visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<CouponLineScanEventContainerModel>>
    (url, this.getHttpHeader(visa));
  }

  verifyCouponLineScanEventByGuid(guids: string[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/update-status' ;
    return this.httpClient.post(url, guids, this.getHttpHeader(visa));
  }
}
